import React, { useState, useEffect } from "react";
import "./styles.scss";
import { Link, useLocation } from "react-router-dom";
import UploadOverlay from "./UploadOverlay";
import uploadButtonImg from "../../../../public/images/upload-button.png";
import { ReactComponent as QuestionMarkIcon } from "../../../../public/icons/circle-question-mark.svg";
import RollOver from "../../../RollOver";
import PrimoSubscriptionModal from "../PrimoSubscriptionModal";
import { useSelector } from "react-redux";
import { isDistroEnabled } from "../../../../helper/helper";
import get from "lodash/get";

export default ({ user }) => {
  const { hash } = useLocation();
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [overlayVisible, setOverlayVisiblity] = useState(false);
  const { current_user } = useSelector(({ current_user }) => ({
    current_user,
  }));
  const email = current_user && get(current_user, "email", null);
  const user_type = current_user && get(current_user, "user_type", null);

  const hideOverlay = () => {
    setOverlayVisiblity(false);
  };
  const showOverlay = () => {
    setOverlayVisiblity(true);
  };
  useEffect(() => {
    document.addEventListener("dragenter", hideOverlay);
  }, []);

  const handleDistributeClick = (e) => {
    if (current_user.is_subscribed_to_primo) {
      e.preventDefault();
      window.location.href = process.env.REACT_APP_EVEARA_BASE_URL;
      return false;
    } else {
      setSubscribeModal(true);
    }
  };

  const text = current_user?.is_subscribed_to_primo
    ? `<b><a style="text-decoration:none" className="text-white" href="#primo-info">Click Here to learn more about primo and distributing unlimited music.</a></b>`
    : `<b><a style="text-decoration:none" className="text-white" href="#primo">Subscribe to PRIMO and distribute unlimited music.Click Here to learn more about it.</a></b>`;

  return (
    <>
      <div className="last-section">
        {current_user && (
          <div className="my-3 d-flex justify-content-center">
            <img
              id="upload-modal-btn"
              onClick={showOverlay}
              src={uploadButtonImg}
            />
          </div>
        )}
        {overlayVisible && <UploadOverlay user={user} hide={hideOverlay} />}
        {current_user && isDistroEnabled(email, user_type) && (
          <div className="my-3 d-flex justify-content-center">
            <Link
              to="/join"
              style={{ paddingTop: 14, paddingBottom: 14 }}
              className="btn btn-primary justify-content-center distribute-button"
              onClick={handleDistributeClick}
            >
              Distribute My Music
            </Link>
            {/* <RollOver
              className="aside-menu-distribute-icon"
              html={text}
              placement="top"
              wrapperElementClassname="d-flex flex-column justify-content-center"
              htmlWrapperElement="div"
            >
              <QuestionMarkIcon className="circle-question-icon" />
            </RollOver> */}
            {(subscribeModal || ["#primo", "#primo-info"].includes(hash)) && (
              <PrimoSubscriptionModal
                showModal={subscribeModal}
                setSubscribeModal={setSubscribeModal}
                hash={["#primo", "#primo-info"].includes(hash)}
                showDistributingInfo={hash === "#primo-info"}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};
